import React, { useEffect, useState } from "react";
import classes from "./ProfilePage.module.css";
import { motion } from "framer-motion";
import { deactivateUserApi } from "../http/http";
import { toast } from "react-toastify";
import {
  FaArrowLeft,
  FaUser,
  FaArrowRightFromBracket,
} from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { userProfileApi } from "../http/http";
import { useDispatch, useSelector } from "react-redux";
import EditProfileModal from "../component/EditProfileModal";
import { removeUser } from "../store/slices/userSlice";
import { useTranslation } from "react-i18next";

const getInitials = (name = "") =>
  name?.split(" ")
    .map((item) => item[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

const ProfilePage = () => {
  const navigate = useNavigate();

  const [userProfile, setUserProfile] = useState({});
  const [loading, setLoading] = useState(true);
  const [unsubscribing, setUnsubscribing] = useState(false);
const [showUnsubscribeConfirm, setShowUnsubscribeConfirm] = useState(false);
// const user = useSelector(
//   (state) =>
//     state?.persisted?.userSlice?.user ??
//     state?.persisted?.user ??
//     state?.userSlice?.user ??
//     state?.user ??
//     null
// );
 const user = useSelector(
    (state) =>
      state?.persisted?.userSlice?.user ??
      state?.persisted?.userSlice ??
      null
  );
  const [modal, setModal] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();
const fetchUserProfile = async () => {
  if (!user?.token) {
    setLoading(false);
    return;
  }

  try {
    setLoading(true);

    const response = await userProfileApi(user.token);
    const profile = response?.data?.result?.[0];

    setUserProfile(profile || {});
  } catch (error) {
    console.error("Failed to fetch profile:", error);
    setUserProfile({});
  } finally {
    setLoading(false);
  }
};

useEffect(() => {
  fetchUserProfile();
}, [user?.token]);

  const handleLogout = () => {
    dispatch(removeUser());
    navigate("/login");
  };

  
const handleUnsubscribe = async () => {
  if (unsubscribing) return;

  // Prefer the number returned by the profile API.
  const msisdn = userProfile?.msisdn ||  user?.msisdn || localStorage.getItem("msisdn");

// if (!msisdn) {
//   toast.error(t("139"));
//   return;
// }
console.log(msisdn,"===msisdn===");
  try {
    setUnsubscribing(true);

    const response = await deactivateUserApi(msisdn);
    const result = response?.data;

    if (result?.status === 1) {
toast.success(result.message || t("136"));
      setShowUnsubscribeConfirm(false);

      // Clear the authenticated session only after success.
      dispatch(removeUser());
      localStorage.removeItem("msisdn");

      navigate("/subscribe", { replace: true });
      return;
    }

    toast.error(result?.message || "Unable to unsubscribe.");
  } catch (error) {
    const result = error?.response?.data;

  if (result?.message === "Subscription does not exist.") {
  toast.error(t("137"));
} else {
  toast.error(t("138"));

    }
  } finally {
    setUnsubscribing(false);
  }
};

  return (
    <main className={classes.main}>
      <div className={classes.bgGlowOne}></div>
      <div className={classes.bgGlowTwo}></div>
      <div className={classes.bgGrid}></div>

      <section className={classes.wrapper}>
        <motion.div
          className={classes.topBar}
          initial={{ opacity: 0, y: -18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
        >
          <motion.button
            className={classes.backBtn}
            onClick={() => navigate(-1)}
            whileHover={{ x: -3, scale: 1.04 }}
            whileTap={{ scale: 0.96 }}
          >
            <FaArrowLeft />
          </motion.button>

          <div className={classes.headerContent}>
            <div className={classes.headerTopLine}>
              <span className={classes.headerDot}></span>
              <span className={classes.headerMiniText}>{t("94")}</span>
            </div>

            <h1 className={classes.pageTitle}>{t("95")}</h1>

            <div className={classes.headerBottomRow}>
              <p className={classes.pageSubTitle}>
                {t("96")}
              </p>
            </div>
          </div>
        </motion.div>

        <motion.section
          className={classes.profileHero}
          initial={{ opacity: 0, y: 24, scale: 0.98 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: 0.4 }}
        >
          <div className={classes.profileLeft}>
            <div className={classes.avatarWrap}>
              <div className={classes.avatar}>

                {userProfile?.image ? (
                  <img
                    src={userProfile?.image}
                    alt={userProfile?.name || "User"}
                    className={classes.avatarImage}
                  />
                ) : (
                  //     <img
                  //   src={"/images/dummy.png"}
                  //   alt={userProfile?.name || "User"}
                  //   className={classes.avatarImage}
                  // />
                  getInitials(userProfile?.name) || 'User'
                )}
                {/* {getInitials(userProfile?.name)} */}
              </div>
            </div>

            <div className={classes.profileInfo}>
              <div className={classes.nameRow}>
                <h2 className={classes.userName}>{userProfile?.name}</h2>
                <span className={classes.statusBadge} onClick={() => setModal(true)}>{t("97")}</span>
              </div>

              <div className={classes.userMeta}>
                <div className={classes.metaItem}>
                  <FaUser />
<span>
  {userProfile?.msisdn || user?.msisdn || ""}
</span>                </div>
              </div>
            </div>
          </div>
        </motion.section>

        <motion.section
          className={classes.subscriptionCard}
          initial={{ opacity: 0, y: 22 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.35 }}
        >
       
<div className={classes.subscriptionBottom}>
  <button
    className={classes.secondaryBtn}
    onClick={() => navigate("/home")}
  >
    {t("105")}
  </button>

  <button
    type="button"
    className={classes.unsubscribeBtn}
    onClick={() => setShowUnsubscribeConfirm(true)}
    disabled={unsubscribing}
  >
    {t("130")}
  </button>

  <motion.button
    className={classes.logoutBtn}
    whileHover={{ scale: 1.03 }}
    whileTap={{ scale: 0.97 }}
    onClick={handleLogout}
  >
    <FaArrowRightFromBracket />
    {t("106")}
  </motion.button>
</div>

        </motion.section>
      </section>

      <EditProfileModal
        modal={modal}
        setModal={setModal}
        name={userProfile?.name}
        image={userProfile?.image}
        fetchUserProfile={fetchUserProfile}
      />
      

{showUnsubscribeConfirm && (
  <div className={classes.confirmOverlay}>
    <motion.div
      className={classes.confirmModal}
      role="dialog"
      aria-modal="true"
      aria-labelledby="unsubscribe-title"
      initial={{ opacity: 0, scale: 0.94, y: 15 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ duration: 0.25 }}
    >
      <h2 id="unsubscribe-title">{t("131")}</h2>

      <p>{t("132")}</p>

      <div className={classes.confirmActions}>
        <button
          type="button"
          className={classes.cancelBtn}
          onClick={() => setShowUnsubscribeConfirm(false)}
          disabled={unsubscribing}
        >
          {t("133")}
        </button>

        <button
          type="button"
          className={classes.unsubscribeBtn}
          onClick={handleUnsubscribe}
          disabled={unsubscribing}
        >
          {unsubscribing ? t("134") : t("135")}
        </button>
      </div>
    </motion.div>
  </div>
)}


    </main>
  );
};

export default ProfilePage;